
const digest = 'a1c0edf52ae4bf96e0f6171d5fb889d26b98cbdb144dafdf43b7546c2a7527fd';
const classes = {"wrapper":"_wrapper_niwzu_1","textBold":"_textBold_niwzu_6","controls":"_controls_niwzu_9"};
const css = `._wrapper_niwzu_1 {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
._wrapper_niwzu_1 ._textBold_niwzu_6 {
  font-weight: 500;
}
._wrapper_niwzu_1 ._controls_niwzu_9 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  margin-top: 10px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  